import { defineMessages } from "react-intl";

const messages = defineMessages({
  newVersionTitle: {
    defaultMessage: "Application update detected",
    description: "notification title"
  },
  newVersionContent: {
    defaultMessage:
      "You need to update eOrdering to the newest version. To update, use the button below.",
    description: "new version notification content"
  },
  refresh: {
    defaultMessage: "Refresh",
    description: "button"
  }
});

export default messages;
